import { omit } from 'lodash'

import { serverResponse } from 'app'

import * as actions from '../../actions/creator'

export const getCreatorInitialState = () =>
  serverResponse({
    fields: {},
    serverResponse: {},
  })

export default (state = getCreatorInitialState(), action = {}) => {
  switch (action.type) {
    case actions.TRN_CREATOR_FETCH: {
      return serverResponse(getCreatorInitialState(), { loading: true })
    }
    case actions.TRN_CREATOR_FETCH_CANCELED: {
      return getCreatorInitialState()
    }
    case actions.TRN_CREATOR_FETCH_ERROR: {
      return serverResponse(getCreatorInitialState(), {
        ...action.payload,
        serverResponse: {},
      })
    }
    case actions.TRN_CREATOR_FETCH_FULFILLED: {
      return serverResponse(getCreatorInitialState(), action.payload)
    }

    case actions.TRN_CREATOR_RESET: {
      return getCreatorInitialState()
    }
    case actions.TRN_CREATOR_SAVE_FETCH: {
      return {
        ...state,
        serverResponse: serverResponse({}, { loading: true }),
      }
    }
    case actions.TRN_CREATOR_SAVE_FETCH_CANCELED: {
      return {
        ...state,
        serverResponse: {},
      }
    }
    case actions.TRN_CREATOR_SAVE_FETCH_ERROR: {
      return {
        ...state,
        serverResponse: action.payload,
      }
    }

    case actions.TRN_CREATOR_SAVE_FETCH_FULFILLED: {
      return {
        ...state,
        serverResponse: action.payload,
      }
    }
    case actions.TRN_CREATOR_VALUES: {
      return {
        ...state,
        fields: {
          ...state.fields,
          ...action.payload,
        },
      }
    }
    case actions.TRN_CREATOR_VALUES_CLEANUP: {
      return {
        ...state,
        fields: {},
      }
    }
    case actions.TRN_CREATOR_VALUES_REMOVE: {
      return {
        ...state,
        fields: omit(state.fields, action.payload),
      }
    }

    default:
  }
  return state
}
